import { Control } from 'react-hook-form';
import {
    IJobQuestionsForm,
    JobQuestionObjectFields,
} from '../../../../../../common';
import {
    FormInputText,
    FormSelector,
    FormSwitch,
    Typography,
    useTheme,
    IOption,
} from '../../../../../../base';
import {
    StyledQuestionFieldsContainer,
    StyledQuestionTitleWrapper,
    StyledQuestionTypeWrapper,
    StyledTogglesContainer,
    StyledToggleItem,
} from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

interface QuestionMainFieldsProps {
    fieldNamePrefix: `questions.${number}`;
    control: Control<IJobQuestionsForm>;
    hasBeenSubmitted: boolean;
    hasQuestionTitleError: boolean;
    shouldShowDealbreaker: boolean;
    questionTypeOptions: IOption[];
    onDealbreakerChange?: (checked: boolean) => void;
}

export const QuestionMainFields = ({
    fieldNamePrefix,
    control,
    hasBeenSubmitted,
    hasQuestionTitleError,
    shouldShowDealbreaker,
    questionTypeOptions,
    onDealbreakerChange,
}: QuestionMainFieldsProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <StyledQuestionFieldsContainer>
            {/* Question Title Input */}
            <StyledQuestionTitleWrapper>
                <FormInputText
                    name={`${fieldNamePrefix}.${JobQuestionObjectFields.QUESTION_TITLE}`}
                    control={control}
                    placeholder={t('saveJob.questionTitlePlaceholder')}
                    size="small"
                    removeBottomPadding={
                        !hasBeenSubmitted || !hasQuestionTitleError
                    }
                    inputProps={{ maxLength: 255 }}
                />
            </StyledQuestionTitleWrapper>

            {/* Question Type Dropdown */}
            <StyledQuestionTypeWrapper>
                <FormSelector
                    name={`${fieldNamePrefix}.${JobQuestionObjectFields.QUESTION_TYPE}`}
                    control={control}
                    label={t('saveJob.questionType')}
                    size="small"
                    options={questionTypeOptions}
                    disableClearable={true}
                    required={true}
                />
            </StyledQuestionTypeWrapper>

            {/* Toggles Container */}
            <StyledTogglesContainer>
                {/* Required Toggle */}
                <StyledToggleItem>
                    <Typography
                        variant="body2"
                        sx={{ color: theme.palette.text.secondary }}
                    >
                        {t('saveJob.required')}
                    </Typography>
                    <FormSwitch
                        name={`${fieldNamePrefix}.${JobQuestionObjectFields.IS_REQUIRED}`}
                        control={control}
                    />
                </StyledToggleItem>

                {/* Dealbreaker Toggle */}
                {shouldShowDealbreaker && (
                    <StyledToggleItem>
                        <Typography
                            variant="body2"
                            sx={{ color: theme.palette.text.secondary }}
                        >
                            {t('saveJob.dealbreaker')}
                        </Typography>
                        <FormSwitch
                            name={`${fieldNamePrefix}.${JobQuestionObjectFields.IS_DEALBREAKER}`}
                            control={control}
                            onChange={onDealbreakerChange}
                        />
                    </StyledToggleItem>
                )}
            </StyledTogglesContainer>
        </StyledQuestionFieldsContainer>
    );
};
